<div
  [@fade]
  class="toast-message flex space-between"
  [ngClass]="{
    'toast-message_success': toast.toastType === EToastType.SUCCESS,
    'toast-message_fail':
      toast.toastType === EToastType.FAIL || toast.toastType === EToastType.ERROR,
    'toast-message_warn': toast.toastType === EToastType.WARN,
    'toast-message_info': toast.toastType === EToastType.INFO,
    'toast-message_error': toast.toastType === EToastType.ERROR_RED
  }"
>
  <div class="flex">
    <stxt-svg-icon
      [iconConfig]="toastIcon"
      class="success-toast_check-svg {{ toast.toastType }}-toast_svg"
    ></stxt-svg-icon>
    <div class="toast-message_body">
      <p class="toast-message_heading">{{ toast?.toastHeading }}</p>
      <p *ngIf="toast.toastType !== EToastType.FAIL" class="toast-message_subheading">
        {{ toast?.toastSubheading }}
      </p>
      <p *ngIf="toast.toastType === EToastType.FAIL" class="toast-message_subheading">
        Please try again later or
        <span (click)="openSupport()" (keydown.enter)="openSupport()" tabindex="-1">
          <span class="toast-message_underline">contact support</span>
          <span>.</span>
        </span>
      </p>
      <div class="toast_buttons">
        <button
          *ngIf="toast.buttonPrimary"
          (click)="buttonEvent.emit(toast.buttonPrimary)"
          class="toast_button__primary btn-nostyle"
        >
          {{ toast.buttonPrimary }}
        </button>
        <button
          *ngIf="toast.buttonSecondary"
          (click)="buttonEvent.emit(toast.buttonSecondary)"
          class="toast_button btn-nostyle"
        >
          {{ toast.buttonSecondary }}
        </button>
      </div>
    </div>
  </div>
  <stxt-svg-icon
    *ngIf="showCloseButton"
    [iconConfig]="closeIcon"
    (click)="closeToast.emit()"
    (keydown.enter)="closeToast.emit()"
    tabindex="-1"
    class="{{ toast.toastType }}-toast_svg"
  ></stxt-svg-icon>
</div>
